// Custom pricing (EUR / month) — same for all locations; internal tier ids (not provider labels)
export const CUSTOM_PRICING = {
  currency: 'EUR',
  tiers: [
    {
      id: 'p1',
      name: 'START',
      price: 13.99,
      specs: {
        cores: 2,
        ram: 6,
        storage: 40,
        bandwidth: '10 Gbit',
        cpu: '4.5 GHz Base (5.7 GHz Turbo)'
      }
    },
    {
      id: 'p2',
      name: 'CORE',
      price: 20,
      specs: {
        cores: 4,
        ram: 8,
        storage: 60,
        bandwidth: '10 Gbit',
        cpu: '4.5 GHz Base (5.7 GHz Turbo)'
      }
    },
    {
      id: 'p3',
      name: 'EDGE',
      price: 30,
      specs: {
        cores: 6,
        ram: 12,
        storage: 80,
        bandwidth: '10 Gbit',
        cpu: '4.5 GHz Base (5.7 GHz Turbo)'
      }
    },
    {
      id: 'p4',
      name: 'PRO',
      price: 40,
      specs: {
        cores: 8,
        ram: 16,
        storage: 100,
        bandwidth: '10 Gbit',
        cpu: '4.5 GHz Base (5.7 GHz Turbo)'
      }
    },
    {
      id: 'p5',
      name: 'MAX',
      price: 50,
      specs: {
        cores: 10,
        ram: 20,
        storage: 120,
        bandwidth: '10 Gbit',
        cpu: '4.5 GHz Base (5.7 GHz Turbo)'
      }
    },
    {
      id: 'p6',
      name: 'ULTRA',
      price: 60,
      specs: {
        cores: 12,
        ram: 24,
        storage: 140,
        bandwidth: '10 Gbit',
        cpu: '4.5 GHz Base (5.7 GHz Turbo)'
      }
    },
    {
      id: 'p7',
      name: 'ELITE',
      price: 70,
      specs: {
        cores: 14,
        ram: 28,
        storage: 160,
        bandwidth: '10 Gbit',
        cpu: '4.5 GHz Base (5.7 GHz Turbo)'
      }
    },
    {
      id: 'p8',
      name: 'APEX',
      price: 80,
      specs: {
        cores: 16,
        ram: 32,
        storage: 180,
        bandwidth: '10 Gbit',
        cpu: '4.5 GHz Base (5.7 GHz Turbo)'
      }
    }
  ]
};

/** Old URLs (?plan=bronze) still resolve after rename. */
const LEGACY_PLAN_IDS = {
  bronze: 'p1',
  silver: 'p2',
  gold: 'p3',
  platinum: 'p4',
  diamond: 'p5',
  titanium: 'p6',
  obsidian: 'p7',
  legend: 'p8'
};

/** Map custom tier id → AcerDP package id (for upgrades). */
export const TIER_TO_ACERDP = {
  p1: 10030,
  p2: 10052,
  p3: 10053,
  p4: 10054,
  p5: 10055,
  p6: 10056,
  p7: 10057,
  p8: 10058,
};

/** Map AcerDP package name → custom tier id. */
export const ACERDP_NAME_TO_TIER = {
  Bronze: 'p1', Silver: 'p2', Gold: 'p3', Platinum: 'p4',
  Diamond: 'p5', Titanium: 'p6', Obsidian: 'p7', Legend: 'p8',
};

export function normalizePlanTierId(raw) {
  if (raw === undefined || raw === null) return '';
  const k = String(raw).trim().toLowerCase();
  return LEGACY_PLAN_IDS[k] || k;
}

/** Monthly price as a number (optional legacy: per-location object on `tier.price`). */
export const resolveTierMonthlyPriceEUR = (tier, location = 'us') => {
  const p = tier?.price;
  if (typeof p === 'object' && p !== null) {
    const v = p[location] ?? p.us;
    return Number(v) || 0;
  }
  return Number(p) || 0;
};

/**
 * Card UI: amount glued to euro sign (e.g. "13.99€", "30€").
 */
export const formatTierMonthlyPriceDisplay = (tier, location = 'us') => {
  const n = resolveTierMonthlyPriceEUR(tier, location);
  if (!Number.isFinite(n)) return '0€';
  const cents = Math.round(n * 100) % 100;
  const s = cents !== 0 ? n.toFixed(2) : String(Math.round(n));
  return `${s}€`;
};

/** Monthly price in EUR for a tier (optional legacy: per-location object). */
export const getCustomPrice = (tierId, location = 'us') => {
  const id = normalizePlanTierId(tierId);
  const tier = CUSTOM_PRICING.tiers.find((t) => t.id === id);
  if (!tier) return 0;
  return typeof tier.price === 'object' ? tier.price[location] || tier.price.us : tier.price;
};

export const getCustomSpecs = (tierId) => {
  const id = normalizePlanTierId(tierId);
  const tier = CUSTOM_PRICING.tiers.find((t) => t.id === id);
  return tier ? tier.specs : null;
};
